// Constants
import {
  UPLOAD_ID_CONTINUE_BUTTON_CLICK_TRACKING,
  UPLOAD_ID_PAGE_DISPLAYED_TRACKING,
} from '../constants/upload-id-landing.tracking.constants';
// Types
import {
  TrackingLinkEventReturnType,
  TrackingViewEventReturnType,
} from '@openbank/ziniaweb-ui-core-models';
import { TrackBuilderType } from 'types/track-builder.type';
import { UploadIdTrackingHandlersType } from './types/upload-id-landing.tracking.handlers.type';

const uploadIDLandingPageDisplayedTracking = (): TrackingViewEventReturnType =>
  UPLOAD_ID_PAGE_DISPLAYED_TRACKING;

const continueButtonClickTracking = (): TrackingLinkEventReturnType =>
  UPLOAD_ID_CONTINUE_BUTTON_CLICK_TRACKING;

const UploadIdTrackingHandlers = (track: TrackBuilderType): UploadIdTrackingHandlersType => ({
  handlePageDisplayedTracking: () => track(uploadIDLandingPageDisplayedTracking()),
  handleContinueButtonClickTracking: () => track(continueButtonClickTracking()),
});

export { UploadIdTrackingHandlers };
